import { defineStore } from 'pinia';
import { parseFormData } from './applicationStore';

const DEFAULT_REDIRECT = 'profile';

export const useRedirectStore = defineStore('redirectStore', {
    state: () => ({
        login: DEFAULT_REDIRECT,
        saveAndExit: DEFAULT_REDIRECT
    }),

    actions: {
        isDefaultRedirect() {
            return this.login === DEFAULT_REDIRECT && this.saveAndExit === DEFAULT_REDIRECT;
        },

        setLoginRedirect(redirect) {
            this.login = redirect || DEFAULT_REDIRECT;
        },

        setSaveAndExitRedirect(redirect) {
            this.saveAndExit = redirect || DEFAULT_REDIRECT;
        },

        clearRedirects() {
            this.login = DEFAULT_REDIRECT;
            this.saveAndExit = DEFAULT_REDIRECT;
        },

        clearSaveAndExit() {
            this.saveAndExit = DEFAULT_REDIRECT;
        },

        saveToLocalStorage() {
            try {
                const parsedData = parseFormData(this.$state);
                localStorage.setItem('redirectStore', JSON.stringify(parsedData));
            } catch (error) {
                console.error('Error saving to localStorage:', error);
            }
        },

        loadFromLocalStorage() {
            try {
                const savedState = localStorage.getItem('redirectStore');
                if (savedState) {
                    this.$patch(parseFormData(JSON.parse(savedState)));
                }
            } catch (error) {
                console.error('Error loading from localStorage:', error);
            }
        }
    }
});
